import { useMemo } from "react";
import { useStore } from "ra-core";

import type { SponsoringStage } from "../types";
import { defaultConfiguration } from "./defaultConfiguration";

export const CONFIGURATION_STORE_KEY = "app.configuration";

export interface ConfigurationContextValue {
  sponsoringStages: SponsoringStage[];
  /** Stages that count as a running sponsorship ("won") */
  sponsoringActiveStatuses: string[];
  /** Stages that are closed; never shown on the board */
  sponsoringClosedStatuses: string[];
  title: string;
  /** Colour lockup (imported asset, absolute URL or data URI) */
  logo: string;
}

export const useConfigurationContext = () => {
  const [config] = useStore<ConfigurationContextValue>(
    CONFIGURATION_STORE_KEY,
    defaultConfiguration,
  );
  // Merge with defaults so that missing fields in stored config
  // fall back to default values (e.g. when new settings are added)
  return useMemo(() => ({ ...defaultConfiguration, ...config }), [config]);
};

export const useConfigurationUpdater = () => {
  const [, setConfig] = useStore<ConfigurationContextValue>(
    CONFIGURATION_STORE_KEY,
  );
  return setConfig;
};
